import { useAppSelector } from "@assessment/store/store";
import { sampleTestCase } from "@assessment/types/assessmentOngoing";
import GetHeroIcon from "@lxp-app/utils/getHeroIcon";
import { useEffect, useState } from "react";

interface TestCaseListing {
  sampleTestCases: sampleTestCase[];
}

const TestCaseListing = ({ sampleTestCases }: TestCaseListing) => {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const activeQuestionMeta = useAppSelector(
    (store) => store.AssessmentSlice.activeQuestionMeta
  );

  useEffect(() => {
    setExpandedIndex(null);
  }, [activeQuestionMeta?.questionId]);

  const toggleIndex = (index: number) => {
    setExpandedIndex((prev) => (prev === index ? null : index)); // toggle if same, otherwise open new
  };

  return (
    <>
      <div className="space-y-4 my-5">
        {sampleTestCases.map((testCase: any, index: number) => (
          <div
            key={index}
            className="border border-gray-300 dark:border-none rounded-lg overflow-hidden transition-all"
          >
            {/* Header */}
            <div
              className="p-3 cursor-pointer bg-gray-700 dark:bg-gray-800 text-white  font-semibold text-sm flex gap-2"
              onClick={() => toggleIndex(index)}
            >
              <span>
                {expandedIndex === index ? (
                  <GetHeroIcon
                    name="ChevronDownIcon"
                    variant="outline"
                    className="flex-shrink-0 w-5 h-5"
                  />
                ) : (
                  <GetHeroIcon
                    name="ChevronRightIcon"
                    variant="outline"
                    className="flex-shrink-0 w-5 h-5"
                  />
                )}
              </span>
              <span>Test Case - {index + 1}</span>
            </div>

            {/* Expandable Content */}
            {expandedIndex === index && (
              <div className="p-4 space-y-4 bg-white dark:bg-secondary-bg text-sm">
                <div>
                  <div className="text-base font-medium text-gray-800 mb-2 dark:text-white">
                    Input
                  </div>
                  <div className="p-2 border border-gray-200 dark:border-none bg-gray-100 dark:bg-[#3b3b3b] rounded whitespace-pre-wrap">
                    {testCase.input}
                  </div>
                </div>

                <div>
                  <div className="text-base font-medium text-gray-800 mb-2 dark:text-white">
                    Output
                  </div>
                  <div className="p-2 border border-gray-200 dark:border-none bg-gray-100 dark:bg-[#3b3b3b] rounded whitespace-pre-wrap">
                    {testCase.output}
                  </div>
                </div>

                {testCase?.explanation?.[0] && (
                  <div>
                    <div className="text-base font-medium text-gray-800 mb-2 dark:text-white">
                      Explanation
                    </div>
                    <div>{testCase.explanation[0]}</div>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default TestCaseListing;
